var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._b({ref:"cascader",staticClass:"w-100p",attrs:{"props":_vm.props,"options":_vm.data},on:{"change":_vm.cascaderChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'el-cascader',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }